import { render, staticRenderFns } from "./CouponForm.vue?vue&type=template&id=44a47126&scoped=true&"
import script from "./CouponForm.vue?vue&type=script&lang=ts&"
export * from "./CouponForm.vue?vue&type=script&lang=ts&"
import style0 from "./CouponForm.vue?vue&type=style&index=0&id=44a47126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a47126",
  null
  
)

export default component.exports